import { DataTable } from '@/components/Ui';
import { useSchools } from '@/pages/Schools/schools.hook';

const SchoolList = () => {
  const {
    schoolsList,
    columns,
    schoolListlimit,
    setSchoolListLimit,
    schoolListPage,
    setSchoolListPage,
  } = useSchools();

  return (
    <div>
      <DataTable
        columns={columns}
        value={schoolsList || []}
        withPaginator={true}
        listlimit={schoolListlimit}
        limitHandler={setSchoolListLimit}
        currentPage={schoolListPage}
        currentPageHandler={setSchoolListPage}
        countTotal={schoolsList?.length}
      />
    </div>
  );
};

export default SchoolList;
